// import logo from './logo.svg';
import Routers from './routers';
// Components -----------------------------------
import Header from './components/header';
import Footer from './components/footer';

// CSS------------------------------------
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";

// // Lenis ----------------------->
import 'lenis/dist/lenis.css'


function App() {
  return (
    <div className="App">
        {/* Header ---------------------- */}
        <Header/>
        {/* Routers ------------------------- */}
        <Routers/>   
        {/* Footer --------------------- */}
        <Footer/>
    </div>
  );
}

export default App;
